import { useState, useCallback } from "react"

export const useDynamicForm = (initialItems = []) => {
  const [items, setItems] = useState(initialItems)

  const addItem = useCallback(
    (template = { id: "", key: "", value: "", type: "text" }) => {
      setItems(prev => [...prev, { ...template, id: Date.now().toString() }])
    },
    []
  )

  const removeItem = useCallback(id => {
    setItems(prev => prev.filter(item => item.id !== id))
  }, [])

  const updateItem = useCallback((id, field, value) => {

    setItems(prev =>
      prev.map(item => (item.id === id ? { ...item, [field]: value } : item))
    )
  }, [])

  const handleDragEnd = useCallback(
    result => {
      if (!result.destination) return

      const newItems = Array.from(items)
      const [reorderedItem] = newItems.splice(result.source.index, 1)
      newItems.splice(result.destination.index, 0, reorderedItem)

      setItems(newItems)
    },
    [items]
  )

  const resetItems = useCallback((newItems = []) => {
    setItems(newItems)
  }, [])

  return {
    items,
    addItem,
    removeItem,
    updateItem,
    handleDragEnd,
    resetItems,
    setItems,
  }
}
